var icecream = [
    {
        "id": "43",
        "name": "Cayenne chocolate stracciatella",
        "category": "icecream",
        "img": "https://i.imgur.com/L83RV4m.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.99
    },
    {
        "id": "44",
        "name": "Cardamom black pepper",
        "category": "icecream",
        "img": "https://i.imgur.com/6jiLEnZ.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 1.99
    },
    {
        "id": "45",
        "name": " Butter Baked chocolate",
        "category": "icecream",
        "img": "https://i.imgur.com/S9gaQwq.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.99
    },
    {
        "id": "46",
        "name": "Butter Pecan With Quinoa",
        "category": "icecream",
        "img": "https://i.imgur.com/I8VSQn6.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 2.59
    },
    {
        "id": "47",
        "name": "Candy Cane Grapefruit",
        "category": "icecream",
        "img": "https://i.imgur.com/jX0jkU2.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 3.99
    },
    {
        "id": "48",
        "name": "Salmon vanilla Blueberry",
        "category": "icecream",
        "img": "https://i.imgur.com/zcRNVMR.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 1.69
    },


]
export default icecream;